import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { axiosErrorMessageHelper } from 'shared/utils/axiosErrorMessageHelper'
import { IMeetingAgendaModel } from '../../../models/BoardMeeting'
import { mapBoardCaseListToAgendaModel } from '../../../utils/mapCaseValues'
import proposedService from './proposed.service'
import { IBaseState } from './selector'

export const propopsedCaseAdapter = createEntityAdapter<IMeetingAgendaModel>({
  selectId: (c) => c.caseId,
})

const mamangeProposed = createSlice({
  name: 'manage/proposed',
  initialState: propopsedCaseAdapter.getInitialState<IBaseState>({
    loading: false,
    error: null,

    totalCount: 0,
  }),

  reducers: {
    addOne: propopsedCaseAdapter.addOne,
    removeOne: propopsedCaseAdapter.removeOne,
    removeMany: propopsedCaseAdapter.removeMany,
  },

  extraReducers: (builder) => {
    // Replaces ProposedFetchRequested
    builder.addMatcher(
      proposedService.endpoints.fetchProposed.matchPending,
      (state) => {
        state.error = null
        state.loading = true
      }
    )
    // Replaces ProposedFetchSuccess
    builder.addMatcher(
      proposedService.endpoints.fetchProposed.matchFulfilled,
      (state, action) => {
        state.loading = false
        state.totalCount = action.payload.totalCount

        propopsedCaseAdapter.setAll(
          state,
          mapBoardCaseListToAgendaModel(action.payload)
        )
      }
    )
    // Replaces ProposedFetchError
    builder.addMatcher(
      proposedService.endpoints.fetchProposed.matchRejected,
      (state, action) => {
        state.loading = false

        const err = axiosErrorMessageHelper(action.payload)
        state.error =
          err || 'Det skjedde en feil ved henting av foreslåtte saker'
      }
    )
  },
})

export default mamangeProposed
